export const en = {
    "SuccessfullySaved": "Successfully saved",
    "SuccessfullyDeleted": "Successfully deleted"
}